import { bynderImageProjection, internalReferenceUrl } from './projection';

export const CONTACT_SUPPORT_QUERY = `
  *[_id == $docId][0]{
    ...,
    isIncludedContactSupport,
    "contactSupport": select(
      isIncludedContactSupport => *[_type == "contactSupport"][0]{
        ...,
        imageLink{
          ...,
          ${bynderImageProjection('image', 'bynderImage', "coalesce(bynderImage.textMetaproperties[name == 'Alt_text'][0].value, bynderImage.alt, alt, bynderImage.description, bynderImage.name)")},
          bynderImage,
          link{
            ...,
            "url": ${internalReferenceUrl},
          }
        },
        contactInfo[]{
          title,
          icon,
          textLink{
            text,
            isBold,
            link
          }
        },
        ctaButtons[]{
          ...,
          link {
            ...,
            "href": ${internalReferenceUrl},
            "isOpenInNewTab": coalesce(isOpenInNewTab, newTab)
          }
        }
      }
    )
  }
`;

// Fetch by page locator (works for documents that have either slug.current or type fields)
export const CONTACT_SUPPORT_BY_PAGE_QUERY = `
  *[_type == $pageType && ((defined(slug.current) && slug.current == $slug) || (defined(type) && type == $slug))][0]{
    isIncludedContactSupport,
    "contactSupport": select(
      isIncludedContactSupport => *[_type == "contactSupport"][0]{
        ...,
        imageLink{
          ...,
          ${bynderImageProjection('image', 'bynderImage', "coalesce(bynderImage.textMetaproperties[name == 'Alt_text'][0].value, bynderImage.alt, alt, bynderImage.description, bynderImage.name)")},
          bynderImage,
          link{
            ...,
            "url": ${internalReferenceUrl},
          }
        },
        contactInfo[]{
          title,
          icon,
          textLink{
            text,
            isBold,
            link
          }
        },
        ctaButton{
          ...,
          link{
            ...,
            "href": ${internalReferenceUrl},
            "isOpenInNewTab": coalesce(isOpenInNewTab, newTab)
          }
        }
      }
    )
  }
`;
